// customer服务器，文档参考：https://wiki.tigerbrokers.net/pages/viewpage.action?pageId=20618658
export const HOST = [
    'https://ams-customer-us-test.tigerbrokers.net',
    'https://customer.tradeup.com',
    // 如果需要使用qa环境, 在这里把数字做一个调整,改成对应的环境
    'https://ams-customer-us-test.tigerbrokers.net'
];
export const API = {
    fields: {
        cnArea: '/api/v1/account/field/area', // 国内省市区
        countryUS: '/api/v1/account/field/country_us',
        stateUS: '/api/v1/account/field/state_us',
        careerUS: '/api/v1/account/field/business_career_us',
        companyUS: '/api/v1/account/field/et_company',
        proofUs: '/api/v1/account/field/proof_us',
        country_us_group: '/api/v1/account/field/country_us_group'
    },
    proofUrl: ':path',
    // https://apidocs.tigerfintech.com/repository/1/api/master/apis/web/Web%E6%8E%A5%E5%8F%A3.json#/operations/get-api-v3-individual-account-process
    process: '/api/v3/individual/account/process', // 开户流程
    portal: '/api/v1/individual/account/open', // 提交开户资料
    modify: '/api/v2/individual/account/modify', // 更新开户资料
    // https://apidocs.tigerfintech.com/repository/1/api/master/apis/web/Web%E6%8E%A5%E5%8F%A3.json#/operations/post--api-v1-{category}-application-{application_type}
    postUpdateCustomerInfo: '/api/v1/individual/application/edit', // 修改资料
    checkInfo: '/api/v1/checkinfo', // 开户资料预检查[校验非SSN开户的证件等]
    // 接口文档：https://test-oauth.tigerfintech.com/ams/docs/Customer%20File/index#req_da76c477d3fe4920af425487c9d28c31
    // 此证件上传接口当通用接口使用, 不需要compose_id
    uploadFile: '/file/api/v1/file/upload/user-certificate', // 证件上传
    // https://apidocs.tigerfintech.com/repository/13/api/master/reference/app-web.json#/operations/get--api-v1-ocr-idcard-result
    getOcrResult: '/file/api/v1/ocr/idcard/result',
    setIDPic: '/api/v1/account/pic', // 更新证件地址
    customerInfo: '/api/v1/individual/customer/info', // 客户资料
    available: '/api/v1/individual/account/open/available', // 查询开户类型 marsco / ib
    checkSSN: '/api/v1/individual/customer/profile/check', // 预检查证件号
    getProfile: '/api/v1/individual/customer/profile', // 获取客户基本信息
    /**
     * iblink
     */
    ibLinkAccount: '/api/v1/individual/account/link', // iblink
    zipCodeStates: '/api/v1/account/field/zipcode_to_state', // (marsco)获取地址和zipcode匹配信息
    // 获取全量账户列表: https://apidocs.tigerfintech.com/repository/1/api/master/apis/web/Web%E6%8E%A5%E5%8F%A3.json#/operations/get-api-v1-account-infos
    getAccountInfos: '/api/v1/account/infos',
    // 权限申请相关
    application: {
        // 查询交易权限是否可申请 https://apidocs.tigerfintech.com/repository/1?branch=master&type=api&uri=apis%2Fweb%2FWeb%E6%8E%A5%E5%8F%A3.json#/operations/get--api-v1-application-available
        available: '/api/v1/application/available',
        // 权限开通接口通用版 https://apidocs.tigerfintech.com/repository/1?branch=master&type=api&uri=apis%2Fweb%2FWeb%E6%8E%A5%E5%8F%A3.json#/operations/post--api-v1-{category}-application-{application_type}
        productApply: '/api/v1/individual/application/product'
    },
    // https://apidocs.tigerfintech.com/repository/1/api/master/apis/web/Web%E6%8E%A5%E5%8F%A3.json#/operations/get--api-v1-{category}-application-process
    getApplicationProcess: '/api/v1/individual/application/process', // 查询资料修改进度
    /**
     * 账户升级/开通权限/权限开通状态查询,接口文档：https://apidocs.tigerfintech.com/repository/1/api/master/apis/web/Web%E6%8E%A5%E5%8F%A3.json#/operations/post--api-v1-{category}-application-{application_type}
     * RD renjianjun
     */
    postIndividualApplication: '/api/v1/individual/application/:application_type',
    // (GET)：获取未回复的合规问询, (PUT)： 回复合规问询 文档： https://apidocs.tigerfintech.com/repository/1/api/master/apis/web/Web%E6%8E%A5%E5%8F%A3.json#/operations/get--api-v1-inquiry-answer
    inquiryAnswer: '/api/v1/inquiry/answer',
    getImgUrl: '/file/api/v1/file/retrieve:file', // 获取图片地址
    getApplicationProcessBatch: '/api/v1/application/batch/process', // 批量查询资料修改进度
    postIndividualApplicationBatch: '/api/v1/application/batch/:application_type', // 批量开通权限
    // 检查姓名与拼音是否匹配 https://apidocs.tigerfintech.com/repository/1?branch=master&type=api&uri=apis%2Fweb%2FWeb%E6%8E%A5%E5%8F%A3.json#/operations/get-api-v1-account-name_pinyin_check
    checkPinYin: '/api/v1/account/name_pinyin_check',
    /** 受信联系人相关接口 */
    contacts: {
        getAndPostItem: '/api/v1/individual/customer/contacts', // 获取/添加受信联系人 https://apidocs.tigerfintech.com/repository/1/api/master/apis/web/Web%E6%8E%A5%E5%8F%A3.json#/operations/get--api-v1-individual_us-customer-contacts
        editAndDeleteItem: '/api/v1/individual/customer/contacts/:id' // 编辑/删除受信联系人 https://apidocs.tigerfintech.com/repository/1/api/master/apis/web/Web%E6%8E%A5%E5%8F%A3.json#/operations/put--api-v1-individual_us-customer-contacts-{contact_id}
    },
    /** 开户字段正则校验接口 https://apidocs.tigerfintech.com/repository/1/api/master/apis/web/Web%E6%8E%A5%E5%8F%A3.json#/operations/post-api-v1-regex-check @任建军 */
    postRegexCheck: '/api/v1/regex/check'
};

// 使用cg返回的数据，如果有牌照或者region等多种域名区分，需要在这里逐一展开
export function bindCG() {
    const cfg = CG_API.customer;

    if (cfg) {
        cfg.COMMON && HOST.fill(cfg.COMMON);
    }
}
